module.exports = __webpack_public_path__ + "static/img/control1.ef6c3c12.png";